import {
  FETCH_PAYMENT_STOCK_LOCATIONS_PENDING,
  FETCH_PAYMENT_STOCK_LOCATIONS_REJECTED,
  FETCH_PAYMENT_STOCK_LOCATIONS_FULFILLED,
} from '../constants/paymentStockLocations';

const initialState = {
  pending: true,
  paymentStockLocations: [],
  error: {},
};

export const paymentStockLocations = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_STOCK_LOCATIONS_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PAYMENT_STOCK_LOCATIONS_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PAYMENT_STOCK_LOCATIONS_FULFILLED:
      return {
        ...state,
        paymentStockLocations: action.response.results,
        pending: false,
        error: [],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/paymentStockLocations.js